namespace advisorop.services {

    // The AI Connections screen's calls. Servicer admin only; the API enforces it.
    export class McpClientService {

        readonly apiUrl = "api/mcpclients";

        static $inject = ["$http"];
        constructor(private $http: ng.IHttpService) {
        }

        getServerInfo(): ng.IHttpPromise<domains.IMcpServerInfo> {
            return this.$http.get(`${this.apiUrl}/serverinfo`);
        }

        list(): ng.IHttpPromise<Array<domains.IMcpClient>> {
            return this.$http.get(`${this.apiUrl}/list`);
        }

        create(provider: domains.McpClientProvider, name: string, redirectUris: string[]): ng.IHttpPromise<domains.IMcpClientSecret> {
            return this.$http.post(`${this.apiUrl}/create`, { provider: provider, name: name, redirectUris: redirectUris });
        }

        update(id: number, name: string, redirectUris: string[]): ng.IHttpPromise<domains.IMcpClient> {
            return this.$http.post(`${this.apiUrl}/update`, { id: id, name: name, redirectUris: redirectUris });
        }

        regenerateSecret(id: number): ng.IHttpPromise<domains.IMcpClientSecret> {
            return this.$http.post(`${this.apiUrl}/regeneratesecret`, { id: id });
        }

        revoke(id: number): ng.IHttpPromise<domains.IMcpClient> {
            return this.$http.post(`${this.apiUrl}/revoke`, { id: id });
        }
    }
    angular.module(Constants.ADVOP_SERVICES).service("mcpClientService", McpClientService);
}
